import React from "react";

import "./help.scss";

type Props = Readonly<{
  review: boolean;
}>;

const HelpComponent = ({ review }: Props) => {
  return (
    <div className="zoning-help">
      <h1>Hotkeys</h1>
      <dl>
        {!review && (
          <>
            <dt>
              <kbd>D</kbd> / <kbd>DEL</kbd> / <kbd>BACKSPACE</kbd>
            </dt>
            <dd>deletes all selected zones</dd>
            <dt>
              <kbd>S</kbd>
            </dt>
            <dd>splits selected zone(s) vertically.  If many zones are selected they must be adjacent and of identical width and type.</dd>
            <dt>
              <kbd>M</kbd>
            </dt>
            <dd>Merges selected zones as long as the resulting "megazone" would not overlap any unselected zones.</dd>
            <dt>
                <kbd>SHIFT</kbd>
            </dt>
            <dd>Holding shift while resizing a zone with the mouse will allow the zone to "compress" neighboring zones to it can grow freely</dd>
            <dt>
                <kbd>←</kbd> <kbd>→</kbd> <kbd>↑</kbd> <kbd>↓</kbd>
            </dt>
            <dd>Moves selected zones by one unit in the chosen direction.</dd>
            <dt>
              <kbd>SHIFT</kbd> + <kbd>←</kbd> <kbd>→</kbd> <kbd>↑</kbd> <kbd>↓</kbd>
            </dt>
            <dd>Expands the selected zone by one pixel in the desired direction.  This will compress neighboring zones to allow the expansion.</dd>
            <dt>
              <kbd>CTRL</kbd> + <kbd>←</kbd> <kbd>→</kbd> <kbd>↑</kbd> <kbd>↓</kbd>
            </dt>
            <dd>Shrink the selected zone by one pixel in the desired direction.</dd>
            <dt>
              <kbd>L</kbd>
            </dt>
            <dd>Toggle zone label display style.</dd>
          </>
        )}
        <dt>
          <kbd>+</kbd>
        </dt>
        <dd>zoom in</dd>
        <dt>
          <kbd>-</kbd>
        </dt>
        <dd>zoom out</dd>
        {!review && (
          <>
            <dt>
              <kbd>CTRL</kbd> + <kbd>A</kbd>
            </dt>
            <dd>selects all zones on the page</dd>
            <dt>
              <kbd>CTRL</kbd> + <kbd>S</kbd>
            </dt>
            <dd>saves the current set of zones</dd>
            <dt>
              <kbd>CTRL</kbd> + <kbd>Z</kbd>
            </dt>
            <dd>undo</dd>
            <dt>
              <kbd>CTRL</kbd> + <kbd>Y</kbd> / <kbd>CTRL</kbd> + <kbd>SHIFT</kbd>+ <kbd>Z</kbd>
            </dt>
            <dd>redo</dd>
          </>
        )}
      </dl>

        {!review && (
          <>
            <h1>Table Editor Hotkeys</h1>
            <dl>
              <dt>
                <kbd>ALT</kbd>
              </dt>
              <dd>hold to hide the table lines and cell indices</dd>
              <dt>
                <kbd>←</kbd> <kbd>→</kbd> <kbd>↑</kbd> <kbd>↓</kbd> <kbd>TAB</kbd> <kbd>SHIFT</kbd> + <kbd>TAB</kbd>
              </dt>
              <dd>navigates through the cells</dd>
              <dt>
                <kbd>SHIFT</kbd> + <kbd>CLICK</kbd>
              </dt>
              <dd>selects individual border segment</dd>
              <dt>
              <kbd>D</kbd> / <kbd>DEL</kbd> / <kbd>BACKSPACE</kbd>
              </dt>
              <dd>deletes selected border segment</dd>
              <dt>
              <kbd>M</kbd>
              </dt>
              <dd>merges all selected cells (if this would not cause any overlap of cells)</dd>
              <dt>
              <kbd>I</kbd>
              </dt>
              <dd>toggle implicit state of selected segment</dd>
              <dt>
                <kbd>R</kbd>
              </dt>
              <dd>split a cell horizontally at cursor position</dd>
              <dt>
                <kbd>C</kbd>
              </dt>
              <dd>split a cell vertically at cursor position</dd>
            </dl>
          </>
        )}
    </div>
  );
};
export const Help = React.memo(HelpComponent);
